var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57075 0.292969H14.4293C15.9632 0.292969 17.2071 1.53686 17.2071 3.07075V8.87883C17.2071 10.4127 15.9632 11.6566 14.4293 11.6566H3.57075C2.03686 11.6566 0.792969 10.4127 0.792969 8.87883V3.07075C0.792969 1.53686 2.03686 0.292969 3.57075 0.292969ZM7.23236 8.50004L9.69448 7.23741L12.1566 5.97479L7.23236 3.44953V8.50004Z",
    fill: "#652784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.e4e66dcbfd26994a5c6d7c6ee6264974.svg";
export { ForwardRef as ReactComponent };